import { Col, Row, } from "antd";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import { Helmet } from "react-helmet-async";

const UsageConditionAgreement = () => {

  const contract = useGetContractByType("2005");
  const html = contract?.data?.data?.content || "";

  return (
    <Col xs={24}>
      <Row className="" gutter={[20, 20]}>
        <Helmet>
          <title className="capitalize">{"Kullanım Koşulları"}</title>
        </Helmet>
        <Col xs={24}>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </Col>
      </Row>

    </Col>
  );
};

export default UsageConditionAgreement;
